import { render, staticRenderFns } from "./ui-modal.vue?vue&type=template&id=6e0d25f4&"
import script from "./ui-modal.vue?vue&type=script&lang=js&"
export * from "./ui-modal.vue?vue&type=script&lang=js&"
import style0 from "./ui-modal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports